/* eslint-disable import/no-cycle */
import axios from 'axios';
import _ from 'lodash';

import {
  CustomException,
  getIdToken,
  getListItemsCount,
  isResponseValid,
  throwSAPError,
} from '../helpers/functions';
import i18n from '../helpers/i18nMain';
import {
  GET_CUSTOMER_TABLE_DATA,
  GET_EQUIPMENT_DATA,
  RESET_EQUIPMENT_DATA,
  SET_CUSTOMER_TABLE_STATUS,
  SET_EQUIPMENT_DATA_STATUS,
  SET_SUBMIT_REQUEST_STATUS,
} from '../helpers/types';

const defaultErrorMsg = i18n.t('mainScreenTranslations:INVALID_RESPONSE');
export const getCustomerTableData = (skip, top) => async (dispatch, getState) => {
  try {
    const state = getState();
    const { auth } = state;
    const { systemIP } = auth;
    dispatch({
      type: SET_CUSTOMER_TABLE_STATUS,
      payload: { isLoading: true, failText: '' },
    });
    const idToken = await getIdToken(dispatch, getState);

    const config = {
      headers: {
        'AZURE-AUTH': `${idToken}`,
      },
      params: {},
    };
    let listCount = null;
    if (listCount === null) {
      const url = `${systemIP}/ZAE_CUCM_SRV/ZAE_VH_BUSINESSPARTNER`;
      listCount = await getListItemsCount(config, url);
    }
    if (skip === 0 || (listCount !== null && skip <= listCount)) {
      config.params = {
        ...config.params,
        $top: top,
        $skip: skip,
      };
      const MainService = axios.create({
        baseURL: `${systemIP}/ZAE_CUCM_SRV`,
      });
      const response = await MainService.get('/ZAE_VH_BUSINESSPARTNER', config).catch(
        throwSAPError
      );

      if (isResponseValid(response)) {
        const rData = response.data.d.results;

        dispatch({
          type: GET_CUSTOMER_TABLE_DATA,
          payload: {
            data: rData,
            listCount,
          },
        });
      } else {
        throw new CustomException(defaultErrorMsg);
      }
    }
  } catch (error) {
    dispatch({
      type: SET_CUSTOMER_TABLE_STATUS,
      payload: {
        isLoading: false,
        failText: i18n.t('mainScreenTranslations:UNABLE_TO_LOAD_CUSTOMER_DATA'),
      },
    });
  }
};

export const getCustomerTableDataByFilter = (skip, top, filterStr) => async (
  dispatch,
  getState
) => {
  try {
    const state = getState();
    const { auth } = state;
    const { systemIP } = auth;
    dispatch({
      type: SET_CUSTOMER_TABLE_STATUS,
      payload: { isLoading: true },
    });
    const idToken = await getIdToken(dispatch, getState);

    const config = {
      headers: {
        'AZURE-AUTH': `${idToken}`,
      },
      params: {
        $filter: filterStr,
      },
    };

    let listCount = null;
    if (listCount === null) {
      const url = `${systemIP}/ZAE_CUCM_SRV/ZAE_VH_BUSINESSPARTNER`;
      listCount = await getListItemsCount(config, url);
    }

    if (skip === 0 || (listCount !== null && skip <= listCount)) {
      config.params = {
        ...config.params,
        $top: top,
        $skip: skip,
      };
      const MainService = axios.create({
        baseURL: `${systemIP}/ZAE_CUCM_SRV`,
      });
      const response = await MainService.get('/ZAE_VH_BUSINESSPARTNER', config).catch(
        throwSAPError
      );

      if (isResponseValid(response)) {
        const rData = response.data.d.results;
        dispatch({
          type: GET_CUSTOMER_TABLE_DATA,
          payload: {
            data: rData,
            listCount,
          },
        });
      } else {
        throw new CustomException(defaultErrorMsg);
      }
    }
  } catch (error) {
    dispatch({
      type: SET_CUSTOMER_TABLE_STATUS,
      payload: {
        isLoading: false,
        failText: i18n.t('mainScreenTranslations:UNABLE_TO_LOAD_CUSTOMER_DATA'),
      },
    });
  }
};

export const getEquipmentList = (filterStr, skip = 0, top = 20) => async (dispatch, getState) => {
  try {
    const state = getState();
    const { auth } = state;
    const { systemIP } = auth;
    dispatch({
      type: SET_EQUIPMENT_DATA_STATUS,
      payload: { isEquipmentLoading: true, failText: '' },
    });
    const idToken = await getIdToken(dispatch, getState);

    const config = {
      headers: {
        'AZURE-AUTH': `${idToken}`,
      },
      params: {
        $filter: filterStr,
      },
    };
    let listCount = null;
    if (listCount === null) {
      const url = `${systemIP}/ZAE_CUCM_SRV/ZAE_C_EquipmentCurrentOwner_01`;
      listCount = await getListItemsCount(config, url);
    }
    if (skip === 0 || (listCount !== null && skip <= listCount)) {
      config.params = {
        ...config.params,
        $top: top,
        $skip: skip,
      };
      const MainService = axios.create({
        baseURL: `${systemIP}/ZAE_CUCM_SRV`,
      });
      const response = await MainService.get('/ZAE_C_EquipmentCurrentOwner_01', config).catch(
        throwSAPError
      );
      if (isResponseValid(response)) {
        const rData = response.data.d.results;

        const failTextEquipment = _.isEmpty(rData)
          ? i18n.t('mainScreenTranslations:NO_EQUIPMENTS_FOUND')
          : '';
        dispatch({
          type: GET_EQUIPMENT_DATA,
          payload: {
            data: rData,
            listCount,
            failTextEquipment,
          },
        });
      } else {
        throw new CustomException(defaultErrorMsg);
      }
    }
  } catch (error) {
    dispatch({
      type: SET_EQUIPMENT_DATA_STATUS,
      payload: {
        isEquipmentLoading: false,
        failTextEquipment: i18n.t('mainScreenTranslations:UNABLE_TO_LOAD_EQUIPMENT_DATA'),
      },
    });
  }
};

export const submitComplaint = (
  data,
  handleSuccess,
  handleFail,
  enqueueSnackbar = () => {}
) => async (dispatch, getState) => {
  try {
    const state = getState();
    const { auth } = state;
    const { systemIP } = auth;
    dispatch({
      type: SET_SUBMIT_REQUEST_STATUS,
      payload: { requestSubmitted: true },
    });
    const idToken = await getIdToken(dispatch, getState);

    const config = {
      headers: {
        'AZURE-AUTH': `${idToken}`,
        'X-Requested-With': 'XMLHttpRequest',
      },
      params: {},
    };
    const MainService = axios.create({
      baseURL: `${systemIP}/ZAE_CUCM_SRV/`,
    });
    const response = await MainService.post('/ZAE_FM_CUCM_01Set', data, config).catch(e => {
      let message = e.toString();
      if (e.response.data.error.message.value) {
        message = e.response.data.error.message.value;
      } else if (e.response.status && e.response.statusText) {
        message = `${e.response.status} - ${e.response.statusText}`;
      }
      // console.log(message);
      enqueueSnackbar(message, {
        variant: 'error',
      });
    });

    if (isResponseValid(response)) {
      dispatch({
        type: SET_SUBMIT_REQUEST_STATUS,
        payload: { requestSubmitted: false },
      });
      enqueueSnackbar(i18n.t('mainScreenTranslations:SUCCESSFULLY_SUBMITTED'), {
        variant: 'success',
      });
      handleSuccess();
    } else {
      throw new CustomException(defaultErrorMsg);
    }
  } catch (error) {
    enqueueSnackbar(i18n.t('mainScreenTranslations:SOMETHING_WENT_WRONG'), {
      variant: 'error',
    });
    dispatch({
      type: SET_SUBMIT_REQUEST_STATUS,
      payload: { requestSubmitted: false },
    });
    handleFail();
  }
};

export const resetEquipmentData = () => {
  return { type: RESET_EQUIPMENT_DATA };
};
